<template>
    <h1 align="center" style="font-size: 5rem">CREATORS</h1>
<div class="container">
	<div class="creators">
		<div class="creator">
			<img src="https://randomuser.me/api/portraits/men/21.jpg" alt="">
			<div class="creator_desc">
				<h1>Shohqadam Ergashev</h1>
				<p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Debitis veritatis quod molestiae nostrum! Qui aspernatur consequuntur perferendis veniam quas dolor impedit officia nihil alias atque, doloremque? Impedit autem, vel dolorem!</p>
			</div>
		</div>
	</div>
</div>

</template>